const Loader = () => {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-violet-600">
          
        </div>
      </div>
    );
  };
  
  export default Loader;